// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"19a5506f19df079e3812","857":"e91c54a0a2f8bb5ed755","923":"d0e1ab1262c26eb1955b","2983":"1f728bb13d4fd80b6bef","9279":"460048c8db22e016b900"}[chunkId] + "";
};